export default __webpack_public_path__ + "static/media/031-propeller.da6f1f1b.png";